import { Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { Banner } from "components/common/Banner";
import { BulkScenarioNotice, listProjectIds } from "./bulkScenarioDrafts";

/** A banner for one notice, naming the projects it covers. */
const BulkScenarioNoticeBanner: React.FC<{
    readonly notice: BulkScenarioNotice;
}> = ({ notice }) => (
    <Banner
        intent={notice.intent}
        icon={
            notice.intent === Intent.WARNING
                ? IconNames.WARNING_SIGN
                : IconNames.INFO_SIGN
        }
        title={notice.title}
        description={
            <>
                {notice.description} <b>{listProjectIds(notice.projectIds)}</b>
            </>
        }
    />
);

/** One banner per notice, each naming the projects it covers. */
export const BulkScenarioNoticeBanners: React.FC<{
    readonly notices: ReadonlyArray<BulkScenarioNotice>;
}> = ({ notices }) => (
    <>
        {notices.map((notice) => (
            <BulkScenarioNoticeBanner key={notice.kind} notice={notice} />
        ))}
    </>
);
